import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

export async function fetchUserAdminUrl(): Promise<string> {
  return apiGet<string>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/admin/users/url`);
}
